"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.closeFlexShorthand = exports.openFlexShorthand = void 0;
var shorthand_css_data_1 = require("../shorthand-css-data");
var css_data_types_1 = require("../../css-data-types");
var shorthand_parser_utils_1 = require("../shorthand-parser-utils");
var shorthand_parser_errors_1 = require("../shorthand-parser-errors");
var getFlexShorthandParts = function () {
    return [
        { prop: 'flex-grow', dataType: css_data_types_1.flexGrowDataType, mandatory: true },
        { prop: 'flex-shrink', dataType: css_data_types_1.flexShrinkDataType },
        { prop: 'flex-basis', dataType: css_data_types_1.flexBasisDataType },
    ];
};
// flex
var openFlexShorthand = function () {
    return (0, shorthand_parser_utils_1.createShorthandOpener)({
        prop: 'flex',
        singleKeywordPart: {
            prop: 'flex',
            dataType: css_data_types_1.flexSingleValueDataType,
            partOpener: (0, shorthand_parser_utils_1.singleKeywordShorthandOpener)(shorthand_css_data_1.FLEX_KEYWORD_VALUE_MAP),
        },
        parts: getFlexShorthandParts(),
        shorthandOpener: function (astNodes) {
            var opened = {};
            if ((0, shorthand_parser_utils_1.matchDataType)(css_data_types_1.flexGrowDataType, astNodes, 0)) {
                opened['flex-grow'] = astNodes[0];
                if (astNodes.length > 1) {
                    if ((0, shorthand_parser_utils_1.matchDataType)(css_data_types_1.flexShrinkDataType, astNodes, 1)) {
                        opened['flex-shrink'] = astNodes[1];
                        if (astNodes.length > 2) {
                            if ((0, shorthand_parser_utils_1.matchDataType)(css_data_types_1.flexBasisDataType, astNodes, 2)) {
                                opened['flex-basis'] = astNodes[2];
                            }
                            else {
                                throw new shorthand_parser_errors_1.NoMandatoryPartMatchError('flex', 'flex-basis');
                            }
                        }
                    }
                    else if ((0, shorthand_parser_utils_1.matchDataType)(css_data_types_1.flexBasisDataType, astNodes, 1)) {
                        if (astNodes.length < 3) {
                            opened['flex-basis'] = astNodes[1];
                        }
                        else {
                            throw new shorthand_parser_errors_1.NoMandatoryPartMatchError('flex', 'flex-shrink');
                        }
                    }
                    else {
                        throw new shorthand_parser_errors_1.NoMandatoryPartMatchError('flex', "".concat('flex-shrink', ", ").concat('flex-basis'));
                    }
                }
            }
            else {
                throw new shorthand_parser_errors_1.NoMandatoryPartMatchError('flex', 'flex-grow');
            }
            return opened;
        },
    });
};
exports.openFlexShorthand = openFlexShorthand;
var closeFlexShorthand = function () {
    return (0, shorthand_parser_utils_1.createShorthandCloser)((0, shorthand_parser_utils_1.createShorthandCloserTemplateFromParts)(getFlexShorthandParts()));
};
exports.closeFlexShorthand = closeFlexShorthand;
//# sourceMappingURL=flex-shorthand.js.map